<template>
  <div class="form-group row">
    <label class="col-form-label col-lg-2">Metadata</label>
    <div class="col-lg-10">
      <div v-for="(meta, index) in metadata" :key="index" class="mb-3">
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            placeholder="Key"
            v-model="meta.key"
            @input="emitUpdate"
          />
          <input
            type="text"
            class="form-control"
            placeholder="Value"
            v-model="meta.value"
            @input="emitUpdate"
          />
          <div class="input-group-append" v-if="metadata.length > 1">
            <button
              class="btn btn-outline-danger"
              type="button"
              style="z-index: auto; border: 1px solid #ced4da;"
              @click="removeMetadata(index)"
            >
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="mt-2">
        <a href="#" class="text-primary" @click.prevent="addMetadata">
          <i class="fas fa-plus-circle mr-1"></i> Add Metadata
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MetadataSection',
  props: {
    value: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      metadata: []
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        this.metadata = newVal;
      },
      deep: true
    }
  },
  methods: {
    emitUpdate() {
      this.$emit('input', this.metadata);
    },
    addMetadata() {
      this.metadata.push({
        key: "",
        value: ""
      });
      this.emitUpdate();
    },
    removeMetadata(index) {
      this.metadata.splice(index, 1);
      this.emitUpdate();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ContactDetails/sections/MetadataSection.vue